import React, { Component } from 'react';
import {ContextLoader}  from './../../utils/import.frames'
import icons from './../../utils/import.icons'

interface Props {
    image ?: any,
    index?: any
    nombre?: any
    handleClose?: any
}

interface State{
    indexImage?: number,
    nameImage?: string
}

interface Info {
    name?: keyof typeof ContextLoader,
    imgs?: any,
    ContextLoader?: any
}

class FullGalleryComponent extends Component <Props, State> {

    constructor(props: Props){
        super(props);
        this.state = {
            indexImage: this.props.index,
            nameImage: this.props.nombre,
        }
    }

    handleIncrement = () => {
        let {indexImage} = this.state
        if(indexImage !== undefined){
            if(indexImage === ContextLoader[this.props.nombre]().length - 1){
                this.setState({
                    indexImage: 0
                })
            }
            else{
                this.setState({
                    indexImage: indexImage + 1,
                })
            }
        }
    }

    handleDecrement = () => {
        let {indexImage} = this.state
        if(indexImage !== undefined){
            if(indexImage === 0){
                this.setState({
                    indexImage: ContextLoader[this.props.nombre]().length - 1
                })
            }
            else{
                this.setState({
                    indexImage: indexImage - 1,
                })
            }
        }
    }

    render() {
        return (
            <div className = "full-gallery">
                <div className = "gallery-ui">
                    {
                        ContextLoader[this.props.nombre]().length > 1 ? 
                    <React.Fragment>
                        <button className = "next-img" onClick = {() => this.handleIncrement()}>
                        <img src={icons["back-gallery"]} alt=''></img>
                    </button>
                    <button className = "prev-img" onClick = {() => this.handleDecrement()}>
                        <img src={icons["back-gallery"]} alt=''></img>
                    </button>
                    </React.Fragment>
                    :
                    <></>
                    }
                    

                    <button className = "close-img" onClick = {() => this.props.handleClose()}>
                        <img src={icons["Close"]} alt=''></img>
                    </button>
                </div>
                <img src={ContextLoader[this.props.nombre]()[this.state.indexImage]} className = "full-image-gallery" alt=''></img>
            </div>
        );
    }
}

export default FullGalleryComponent;